(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ExposureSubTypeEditController', ExposureSubTypeEditController);

    ExposureSubTypeEditController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService', '$uibModalInstance', 'ExposureSubType', 'entity', 'mode', 'Workflow'];

     function ExposureSubTypeEditController($scope, $state, $rootScope, GlobalValues, workflowSharedService, $uibModalInstance, ExposureSubType, entity, mode, Workflow) {
        var vm = this;
        vm.exposureSubType=entity;   
        
        vm.clear=clear;
        vm.save=save;
        vm.clicked=false;
        $scope.showButton = false;
        $scope.showApproveRejectButton=false;
        $scope.showDiscardButton = false;
    	$scope.showResubmitButton=false;
        vm.resubmitExposureSubType = resubmitExposureSubType;
        vm.globalValues = GlobalValues;
        vm.discardExposureSubType = discardExposureSubType;
        vm.rejectExposureSubType = rejectExposureSubType;
        vm.approveExposureSubType = approveExposureSubType;
        vm.viewMode=false;
        vm.disabled=false;
        
        $scope.showButton = false;
        vm.orgId = vm.globalValues.getOrgId();
        vm.mode = mode;
        
        if(workflowSharedService.viewFrom == 'exposureSubType'){
        	vm.exposureSubType=entity;
        	$scope.showButton = true;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureSubTypetodolist_resubmit') {
        	vm.exposureSubType =  angular.fromJson($rootScope.payload);
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=true;
        	vm.viewMode=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureSubType_todolist_checker') {
        	vm.exposureSubType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = true;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom == 'exposureSubType_todolist_maker') {
        	vm.exposureSubType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = true;
        	$scope.showResubmitButton=false;
        }
        else if(workflowSharedService.viewFrom=='exposureSubType_auditlog'){
        	vm.exposureSubType =  angular.fromJson($rootScope.payload); 
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
        else if(workflowSharedService.viewFrom=='exposure_sub_type_import_auditlog'){
        	
        	vm.exposureSubType =  angular.fromJson($rootScope.payload);   
        	
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;

        }
		
        if(vm.exposureSubType!=null && vm.exposureSubType.isEnabled!=null && vm.exposureSubType.isEnabled!=undefined){
        	vm.disabled = !vm.exposureSubType.isEnabled;
        }
        
        if(mode=='VIEW'){
        	vm.viewMode=true;
        	$scope.showButton = false;
        	$scope.showApproveRejectButton = false;
        	$scope.showDiscardButton = false;
        	$scope.showResubmitButton=false;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save () {   
        	
        	if(vm.disabled){
        		vm.exposureSubType.isEnabled = false;
        	}else{
        		vm.exposureSubType.isEnabled = true;
        	}
        	
        	if (vm.exposureSubType.id != null) {
				ExposureSubType.update({
					"orgId" : GlobalValues.getOrgId()
				}, vm.exposureSubType, onSaveSuccess, onSaveError);
			} else {
				ExposureSubType.save({
					"orgId" : GlobalValues.getOrgId()
				}, vm.exposureSubType, onSaveSuccess, onSaveError);
			}
        	
         }
      
       
        function onSaveSuccess (result) {
        	 $uibModalInstance.close(result);  
        }
        
      
        function onSaveError () {
        	
        	vm.clicked = false;
        }
        function resubmitExposureSubType() {
        	
        	if(vm.disabled){
        		vm.exposureSubType.isEnabled = false;
        	}else{
        		vm.exposureSubType.isEnabled = true;
        	}
        	
        	ExposureSubType.resubmit({"taskId" : $rootScope.taskID}, vm.exposureSubType, onResubmitSuccess, onResubmitError);
        	
       		
        	$uibModalInstance.dismiss('cancel');
        }
        
        function onResubmitSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);
        }        
        function onResubmitError(error) {
        	vm.clicked = false;
        }
        
        function approveExposureSubType() { 
        	ExposureSubType.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	
        }
       
        function rejectExposureSubType() { Workflow.rejectTask($rootScope.taskID); }

        function discardExposureSubType() {
        	ExposureSubType.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        

        function onDiscardError(error) {
        	
        }

        $scope.$watch('vm.exposureSubType.name', function(newVal, oldVal) {
            if(newVal!=null && newVal!=undefined && newVal!='')
            {
                newVal = newVal.replace(/(\r\n|\n|\r)/gm," ");
                newVal = newVal.replace(/(,)/gm,"");
                newVal = newVal.replace("=","");
                newVal = newVal.replace(/[^\x20-\x7E]/g, '');
                vm.exposureSubType.name = newVal;
                
            }
        });
        
        $scope.$watch('vm.exposureSubType.remarks', function(newVal, oldVal) {
            if(newVal!=null && newVal!=undefined && newVal!='')
            {
                newVal = newVal.replace(/[^\x20-\x7E]/g, '');
                vm.exposureSubType.remarks = newVal;
                
            }
        });

     }   
})();
